import React, { useState, useRef, useEffect } from 'react';
import ThemeToggle from './ThemeToggle';
import { Link } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import avatar from '../assets/Avatar2.png';
import './Header.css';

function Header() {
    const [menuOpen, setMenuOpen] = useState(false);
    const { logout, user } = useAuth0();
    //just take user from useAuth0 dont need set user in AuthGuard
    const dropdownRef = useRef(null);

    const toggleMenu = () => {
        setMenuOpen((prev) => !prev);
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setMenuOpen(false);
            }
        };

        document.addEventListener('mousedown', handleOutsideClick);
        return () => document.removeEventListener('mousedown', handleOutsideClick);
    }, []);

    return (
        <header id='header'>
            <div className="controls-wrapper">
                <ThemeToggle />
                {/* <div className="separator"></div> */}
                <div className='user-account' ref={dropdownRef}>
                    <button className='user-button' onClick={toggleMenu}>
                        <img className='user-image' src={user.picture} alt='avatar'/>
                        <span>{user.name}</span>
                        {/* <span>{user.email}</span> */}
                    </button>
                    <div className={`dropdown-menu ${menuOpen ? 'open' : 'closed'}`}>
                        <ul>
                            <li>
                                <Link to="/my-account">
                                  <div className='icon-wrapper'>
                                    <i className="fa-solid fa-address-card"></i>
                                  </div> 
                                My Account
                                </Link>
                            </li>
                            <li>
                                <button
                                    onClick={() => {
                                        const currentUrl = window.location.origin;

                                        // Broadcast logout event to all tabs
                                        localStorage.setItem("logout", Date.now());

                                        // Perform Auth0 logout and redirect to the root URL
                                        logout({ logoutParams: { returnTo: `${currentUrl}/` } });
                                    }}
                                    className="logout-button">
                                        Logout
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default Header;